import React, { FC } from 'react';
import Routes from './navigation/Routes';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import DefaultTheme from './styles/DefaultTheme';
import ErrorBoundary from './components/common/ErrorBoundary';
import './App.css';

// ✅ COMPONENTE PRINCIPAL CON ERROR BOUNDARY
const App: FC = () => {
  // ✅ MANEJO PERSONALIZADO DE ERRORES
  const handleAppError = (error: Error, errorInfo: any) => {
    // ✅ LOGGING ADICIONAL PARA ERRORES CRÍTICOS
    console.error('Critical app error:', error, errorInfo);

    // ✅ AQUÍ SE PUEDE IMPLEMENTAR:
    // - Envío a servicios de monitoreo
    // - Notificaciones al equipo
    // - Logging estructurado
  };

  return (
    <ErrorBoundary onError={handleAppError}>
      <ThemeProvider theme={DefaultTheme}>
        <CssBaseline />
        <div className="container">
          <div className="App">
            <Routes />
          </div>
        </div>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
